import { Box } from '@mui/material';
import { ReactNode } from 'react';

import './FormInputCollection.scss';

interface FormInputCollectionProps {
  label?: string;
  icon?: ReactNode;
  alignLabel?: 'center' | 'left';
  children: ReactNode;
  style?: React.CSSProperties;
}

const FormInputCollection = ({ label, icon, alignLabel = 'left', children, style }: FormInputCollectionProps) => {
  return (
    <Box className='form-input-collection' style={style}>
      {label && (
        <label className={`form-input-collection__label ${alignLabel === 'center' ? 'form-input-collection__label--center' : ''}`}>
          {icon && (
            <Box component='span' className='form-input-collection__label-icon'>
              {icon}
            </Box>
          )}
          {label}
        </label>
      )}

      <Box className='form-input-collection__content'>{children}</Box>
    </Box>
  );
};

export default FormInputCollection;
